module.exports = __webpack_public_path__ + "static/media/weather2.42648783.png";